module.exports = __webpack_public_path__ + "img/first-transfer-1.687e9dee.gif";